import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import store from './../store'
import Main from './Main'
import Login from './Login'

import HoujinMain from './houjin/Main'
import HoujinLogin from './houjin/Login'

const MINUTES_UNITL_AUTO_LOGOUT = 119; // in minutes
const CHECK_INTERVAL = 15000; // in miliseconds
const STORE_KEY =  'lastAction';

class App extends Component {
    constructor(props) {
        super(props);
        this.check();
        this.initListener();
        this.initInterval();
    };

    getLastAction() {
        return parseInt(localStorage.getItem(STORE_KEY));
    }

    setLastAction(lastAction) {
        localStorage.setItem(STORE_KEY, lastAction.toString());
    }

    initListener() {
        document.body.addEventListener('click', () => this.reset());
        document.body.addEventListener('mouseover',()=> this.reset());
        document.body.addEventListener('mouseout',() => this.reset());
        document.body.addEventListener('keydown',() => this.reset());
        document.body.addEventListener('keyup',() => this.reset());
        document.body.addEventListener('keypress',() => this.reset());
    }

    reset() {
        this.setLastAction(Date.now());
    }

    initInterval() {
        setInterval(() => {
            this.check();
        }, CHECK_INTERVAL);
    }

    check() {
        const now = Date.now();
        const timeleft = this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
        const diff = timeleft - now;
        const isTimeout = diff < 0;
        if (isTimeout) {
            // Call logout function, expire session
            axios.post('/logout').then(response => {
                localStorage.clear();
                if (window.location.href.indexOf('/houjin') > 0) {
                    window.location.href='/houjin/login';
                } else {
                    window.location.href='/';
                }
            });
        }
    }
    render() {
        return (
            <Provider store={store} >
            <BrowserRouter>
                <Switch>
                    <Route exact path='/login' component={Login} />
                    <Route exact path='/houjin/login' component={HoujinLogin} />
                    <Route path='/houjin/' component={HoujinMain} />
                    <Route path='/' component={Main} />
                </Switch>
            </BrowserRouter>
            </Provider>
        );
    }
}

ReactDOM.render(<App />, document.getElementById('app'));
